var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.254,
    height: 93.001,
    viewBox: "0 0 111.254 93.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(-167.597 -1050.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M201.994,1132.835c-4.338.064-8.654.051-12.9-1.151a29.737,29.737,0,0,1,4.631-58.085c.755-.088.9-.471,1.1-1.069,3.841-11.883,11.907-19.118,24.205-21.157,14.569-2.415,28.667,6.771,32.828,21.047a1.476,1.476,0,0,0,1.451,1.248,29.712,29.712,0,0,1,25.3,25.841c2.118,16.272-9.98,31.584-26.361,33.079-4.725.431-9.513.23-14.272.211a3.628,3.628,0,0,1-3.452-3.8,3.68,3.68,0,0,1,3.688-3.585c3.716-.037,7.434.007,11.15-.016a22.305,22.305,0,0,0,.612-44.6c-2.907-.058-4.217-1.176-4.732-4.04a22.249,22.249,0,0,0-43.749-.177c-.61,3.268-1.645,4.141-5,4.219a22.394,22.394,0,0,0-21.429,20.193c-.936,11.483,6.706,21.875,17.729,23.91a46.977,46.977,0,0,0,7.16.484c2.708.078,5.42.013,8.13.02,2.45.006,4.143,1.547,4.128,3.741s-1.7,3.684-4.179,3.692C206.02,1132.839,204.007,1132.835,201.994,1132.835Z",
    transform: "translate(0 0)",
    fill: "#2c3584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M294.115,1159.695c-.479.453-.76.707-1.028.974q-5.465,5.46-10.929,10.92c-1.71,1.7-3.927,1.791-5.477.257a3.7,3.7,0,0,1,.2-5.476q9.065-9.087,18.151-18.153a3.66,3.66,0,0,1,5.554-.038q9.138,9.1,18.234,18.235a3.718,3.718,0,1,1-5.282,5.21c-3.922-3.906-7.827-7.829-11.993-12v1.439q0,22.3-.007,44.609a6.8,6.8,0,0,1-.188,1.832,3.659,3.659,0,0,1-3.9,2.63,3.763,3.763,0,0,1-3.331-3.472c-.026-.385-.011-.774-.011-1.161q0-22.131,0-44.261Z",
    transform: "translate(-74.463 -66.162)",
    fill: "#2c3584"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.ad8669dc929d7e6b784fab48366b8b9c.svg";
export { ForwardRef as ReactComponent };